const PRELOAD_CLASSES = ABV4_SETTINGS.addToCartPreventMultiClick;
import {formatMoney} from "@shopify/theme-currency";

export function disabledPreLoadClick() {
    $(PRELOAD_CLASSES).on('click', (e) => {
        const button = $(e.currentTarget);
        button.css('pointer-events', 'none');
    });

}
function getCookie(name) {
    var pattern = RegExp(name + "=.[^;]*")
    var matched = document.cookie.match(pattern)
    if(matched){
        var cookie = matched[0].split('=')
        return cookie[1]
    }
    return null;
}

function getBundlePrice(bundle) {
    let discountGeneral = bundle.bundle_discount;
    let discountedPrice = 0;
    let originalPrice = 0;
    if(getCookie('localization') != 'US'){
        discountGeneral = 0;
    }
    let discountedAmount = 1 - (discountGeneral * 0.01);
    for (let i = 0; i < bundle.bundle_components.length; i++) {
        const product = bundle.bundle_components[i];
        const qty = product.qty ? product.qty : 1;
        const price = available_bundle_variants[product.id] * qty;
        if(product.hasOwnProperty('discount')){
            discountedAmount = 1 - (product.discount * 0.01)
        } else {
            discountedAmount = 1 - (discountGeneral * 0.01);
        }
        const discountMath = price * discountedAmount;
        discountedPrice += discountMath;
        originalPrice += price;
    }

    return [formatMoney(discountedPrice, window.moneyFormat), formatMoney(originalPrice, window.moneyFormat)];
}

export function bundleLPprices() {
    let bundlePricesObj = {};
    bundlePricesObj['currency_symbol'] = currencySymbol;
    if (typeof bundles_array !== 'undefined') {
        for(const bundle of bundles_array) {
            const bundlePrices = getBundlePrice(bundle);
            bundlePricesObj[bundle.bundle_class] = {
                discounted_price: bundlePrices[0],
                msrp_price: bundlePrices[1]           
             }
        }
    }
    return bundlePricesObj;
}

